<script setup>
import { onMounted, ref } from "vue";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { ARButton } from "three/examples/jsm/webxr/ARButton.js";

const sceneRef = ref(null);

onMounted(() => {
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.xr.enabled = true; // Ativar WebXR
  sceneRef.value.appendChild(renderer.domElement);

  // Criar botão de ativação do modo AR
  const arButton = ARButton.createButton(renderer, {
    requiredFeatures: ["plane-detection"], // Habilita detecção de superfícies
  });
  document.body.appendChild(arButton);

  // Adicionando luz
  const light = new THREE.HemisphereLight(0xffffff, 0xbbbbff, 1);
  scene.add(light);

  const planeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, side: THREE.DoubleSide, wireframe: true });

  // Adicionar lógica para detectar superfícies planas
  let planes = new Map();

  renderer.xr.addEventListener("sessionstart", () => {
    const session = renderer.xr.getSession();

    if (session.requestReferenceSpace) {
      session.requestReferenceSpace("local").then(() => {
        session.addEventListener("select", (event) => {
          console.log("Surface selected:", event);
        });

        session.requestAnimationFrame(() => {
          if (session.detectedPlanes) {
            for (let plane of session.detectedPlanes) {
              if (!planes.has(plane)) {
                const geometry = new THREE.PlaneGeometry(plane.extentX, plane.extentZ);
                const mesh = new THREE.Mesh(geometry, planeMaterial);
                mesh.position.set(plane.pose.x, plane.pose.y, plane.pose.z);
                mesh.rotation.set(plane.rotation.x, plane.rotation.y, plane.rotation.z);
                scene.add(mesh);
                planes.set(plane, mesh);
              }
            }
          }
        });
      });
    }
  });

  // Carregar modelo de eletroduto e caixas de luz
  const loader = new GLTFLoader();
  loader.load("/models/scene.gltf", (gltf) => {
    const model = gltf.scene;
    model.position.set(0, 0, -1); // Posição inicial
    scene.add(model);
  });

  camera.position.set(0, 1.5, 3);

  function animate() {
    renderer.setAnimationLoop(() => {
      renderer.render(scene, camera);
    });
  }

  animate();
});
</script>

<template>
  <div ref="sceneRef" class="three-container"></div>
</template>

<style>
.three-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
